module.exports = ".ui-panel {\n  background-color: red !important;\n  border: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/repository/document-category/form/document-category-form.component.scss
// module id = ./src/app/fiscalia/component/repository/document-category/form/document-category-form.component.scss
// module chunks = main